import React from 'react';
import ReactDOM from 'react-dom/client';

console.log('index.js iniciando...');

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  const App = require('./App').default;
  console.log('App cargado correctamente');
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('App renderizado');
} catch (error) {
  console.error('Error fatal:', error);
  root.render(
    <div style={{ padding: '20px', color: 'red', fontFamily: 'Arial' }}>
      <h1>Error al cargar la aplicación</h1>
      <p><strong>Mensaje:</strong> {error.message}</p>
      <pre style={{ backgroundColor: '#f0f0f0', padding: '10px', overflow: 'auto' }}>
        {error.stack}
      </pre>
    </div>
  );
}
